import { useEffect } from 'react';

import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

interface UseCopyEmployeeServicesModalEffectsParams {
  employeesError: unknown;
}

export const useCopyEmployeeServicesModalEffects = ({
  employeesError,
}: UseCopyEmployeeServicesModalEffectsParams) => {
  const { showNotification } = useNotification();

  useEffect(() => {
    if (employeesError) {
      showNotification(handleCatchError(employeesError));
    }
  }, [employeesError, showNotification]);
};
